import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"

const Post = ({
  post,
  heading = 2,
  category = false,
  meta = false,
  excerpt = false,
}) => {
  return (
    <li className="p-postList__item">
      <Link to={`/${post.parent.name}/`} className="p-postList__link">
        <div className="p-postList__thumb c-postThumb">
          <figure className="c-postThumb__figure">
            {post.frontmatter.image ? (
              <GatsbyImage
                image={post.frontmatter.image.childImageSharp.gatsbyImageData}
                alt={post.frontmatter.title}
                className="c-postThumb__img"
              />
            ) : (
              <StaticImage
                src="../images/noimg.jpg"
                alt="No image"
                className="c-postThumb__img"
              />
            )}
          </figure>
          {category && (
            <div className="p-postList__category u-color-thin u-flex--aic">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                className="arkhe-svg-folder c-postMetas__icon"
                width="1em"
                height="1em"
                viewBox="0 0 40 40"
                role="img"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M15.2,8l3.6,3.6H35V32H5V8H15.2 M16.4,5H2v30h36V8.6H20L16.4,5L16.4,5z" />
              </svg>
              <span>{post.frontmatter.categories[0].title}</span>
            </div>
          )}
        </div>
        <div className="p-postList__body">
          {heading === 2 && (
            <h2 className="p-postList__title">{post.frontmatter.title}</h2>
          )}
          {heading === 0 && (
            <div className="p-postList__title">{post.frontmatter.title}</div>
          )}
          {excerpt && (
            <div className="p-postList__excerpt">
              <p>{post.excerpt}</p>
            </div>
          )}
          {meta && (
            <div className="p-postList__meta c-postMetas u-flex--aicw">
              <div className="p-postList__times c-postTimes u-color-thin u-flex--aic">
                <time
                  className="c-postTimes__item u-flex--aic -posted"
                  dateTime={post.frontmatter.date}
                >
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    className="arkhe-svg-posted c-postMetas__icon"
                    width="1em"
                    height="1em"
                    viewBox="0 0 40 40"
                    role="img"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M21,18.5v-9C21,9.2,20.8,9,20.5,9h-2C18.2,9,18,9.2,18,9.5v12c0,0.3,0.2,0.5,0.5,0.5h10c0.3,0,0.5-0.2,0.5-0.5v-2 c0-0.3-0.2-0.5-0.5-0.5h-7C21.2,19,21,18.8,21,18.5z" />
                    <path d="M20,39C9.5,39,1,30.5,1,20S9.5,1,20,1s19,8.5,19,19S30.5,39,20,39z M20,3.8C11.1,3.8,3.8,11.1,3.8,20S11.1,36.2,20,36.2 S36.2,28.9,36.2,20S28.9,3.8,20,3.8z" />
                  </svg>
                  {post.frontmatter.dateJP}
                </time>
                {post.frontmatter.lastmod &&
                  post.frontmatter.lastmod > post.frontmatter.date && (
                    <time
                      className="c-postTimes__item u-flex--aic -modified"
                      dateTime={post.frontmatter.lastmod}
                    >
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        className="arkhe-svg-modified c-postMetas__icon"
                        width="1em"
                        height="1em"
                        viewBox="0 0 40 40"
                        role="img"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path d="M36.3,14C33.1,5,22.9,0.3,13.9,3.6c-4.1,1.5-7.3,4.3-9.3,7.8l2.7,1.3c1.6-2.8,4.2-5.1,7.6-6.4c7.5-2.7,15.8,1.1,18.6,8.7 L30.6,16l6.5,4.3l2.2-7.5L36.3,14L36.3,14z" />
                        <path d="M31.7,28.5c-1.6,2.3-3.9,4.1-6.9,5.2C17.3,36.4,9,32.5,6.3,25l2.8-1l-6.3-4.2L0.6,27l2.8-1c3.3,9,13.4,13.7,22.4,10.5 c3.7-1.3,6.5-3.8,8.5-6.7L31.7,28.5z" />
                      </svg>
                      {post.frontmatter.lastmodJP}
                    </time>
                  )}
              </div>
            </div>
          )}
        </div>
      </Link>
    </li>
  )
}

export default Post
